import { GridFeatureManager, InstancePlugin } from "@bryntum/schedulerpro";
import { PLUGINS_KEYS } from "../../other/constants/PluginKeys.jsx";

export default class RowReorderExtendPlugin extends InstancePlugin {
  static get $name() {
    return PLUGINS_KEYS.rowReorderExtend;
  }

  static get pluginConfig() {
    return {
      after: ["onGridRowDrop"],
    };
  }

  onGridRowDrop(e) {
    const { context, source: grid } = e;

    if (context.valid) {
      const store = grid.store.swivuMasterStore ?? context.startRecord.firstStore;
      // enabling the ordering assignment if the store model has an "order"
      if (store) {
        // in order to batch changes and prevent ui lag we need to add these two statements
        const commitAsyncPromise = (store.crudManager || store.swivuCrudManager).project.commitAsync();
        grid.suspendRefresh();

        // it's not necessary that the grid store is the same as the master store in the case of lets say we are populating the grid's data using masterStore.query() function
        // in this case then we need to update the records position in the master store
        if (grid.store !== store) {
          if (context.insertBefore?.isGroupHeader) {
            // this is a case where if a record being dragged is dropped into a group collection which is collapsed then the insertBefore will be a group header instead of record
            store.move(context.records, context.insertBefore.groupChildren[0]);
          } else {
            store.move(context.records, context.insertBefore);
          }
        }

        // Note: the following store.query should be called after moving records above
        // do not use forEach as when grid is grouped and headers are collapsed then moving records to another grouped row doesn't call forEach
        const { swivuRowReorderFilterFn } = grid.features.rowReorder;
        // Bug: When row reorder is applied in entity's related data, sometimes order value is updated for records that are not part of the current entity's related data
        // Fix: Added a filter function that can be passed from the grid's rowReorder feature config to filter out records that should not be updated
        // https://admin.dev.swivu.com/swivu-engineering-rjv68i/scheduler?task=105790&tab=general
        if (swivuRowReorderFilterFn) {
          store.query((record) => swivuRowReorderFilterFn(e, record), true)
            .forEach((checklistItem, idx) => {
              checklistItem.order = idx;
            })
        } else {
          store.query((record, idx) => {
            record.order = idx;
          }, true);
        }
        grid.resumeRefresh();
        commitAsyncPromise.then();
      } else {
        if (!store) {
          console.log("Unable to set order, as the firstStore is not found!");
        }
      }
    }
  }
}

GridFeatureManager.registerFeature(RowReorderExtendPlugin, true);
